(function () {
  var COLORS = ['#e85d75', '#f4a261', '#ffd166', '#7cb342', '#42a5f5', '#ab47bc', '#ef5350', '#ff8a80', '#ec407a', '#66bb6a'];
  var stylesInjected = false;

  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;
    var style = document.createElement('style');
    style.textContent =
      '.ph-heart-celebrate{position:fixed;inset:0;pointer-events:none;z-index:2147483646;overflow:visible}' +
      '.ph-heart-celebrate__heart{position:fixed;left:0;top:0;opacity:0;animation:ph-heart-burst ease-out forwards;line-height:1;text-shadow:0 1px 2px rgba(0,0,0,.06)}' +
      '@keyframes ph-heart-burst{0%{opacity:0;transform:translate(-50%,-50%) scale(.25)}12%{opacity:1;transform:translate(-50%,-50%) scale(1)}45%{opacity:1;transform:translate(calc(-50% + var(--ph-x-mid,0px)),calc(-50% + var(--ph-y-mid,0px))) scale(1) rotate(var(--ph-rot-mid,0deg))}100%{opacity:0;transform:translate(calc(-50% + var(--ph-x,0px)),calc(-50% + var(--ph-y,0px))) scale(.9) rotate(var(--ph-rot,180deg))}}' +
      '@media (prefers-reduced-motion:reduce){.ph-heart-celebrate__heart{animation:none!important;opacity:0}}';
    document.head.appendChild(style);
  }

  function findSuccessAnchor(anchor) {
    if (anchor && anchor.getBoundingClientRect) {
      var r = anchor.getBoundingClientRect();
      if (r.width || r.height) return anchor;
    }
    var selectors = [
      '#wholesale-quick-success h2',
      '#wholesale-order-success h2',
      '#wholesale-collection-success h2',
      '#cart-wholesale-success h2',
      '.wholesale-success h2'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      var box = el.closest('.wholesale-success, .cart-wholesale-success-screen, [id$="-success"]');
      if (box && box.style.display === 'none') continue;
      var rect = el.getBoundingClientRect();
      if (rect.width || rect.height) return el;
    }
    return null;
  }

  function celebrateWholesaleOrder(anchor) {
    injectStyles();
    anchor = findSuccessAnchor(anchor);
    if (!anchor) return;

    var rect = anchor.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    var spread = Math.max(rect.width, rect.height, 120) * 0.55;

    var layer = document.createElement('div');
    layer.className = 'ph-heart-celebrate';
    layer.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < 28; i++) {
      var heart = document.createElement('span');
      heart.className = 'ph-heart-celebrate__heart';
      heart.textContent = '♥';
      heart.style.left = cx + 'px';
      heart.style.top = cy + 'px';
      heart.style.color = COLORS[i % COLORS.length];
      heart.style.fontSize = ((10 + Math.random() * 12) * 1.2) + 'px';
      heart.style.animationDuration = 2.2 + Math.random() * 1.2 + 's';
      heart.style.animationDelay = Math.random() * 0.25 + 's';
      heart.style.animationTimingFunction = 'ease-in-out';
      var angle = Math.random() * Math.PI * 2;
      var dist = spread * (0.45 + Math.random() * 0.75);
      heart.style.setProperty('--ph-x', Math.round(Math.cos(angle) * dist) + 'px');
      heart.style.setProperty('--ph-y', Math.round(Math.sin(angle) * dist) + 'px');
      heart.style.setProperty('--ph-x-mid', Math.round(Math.cos(angle) * dist * 0.45) + 'px');
      heart.style.setProperty('--ph-y-mid', Math.round(Math.sin(angle) * dist * 0.45) + 'px');
      heart.style.setProperty('--ph-rot', Math.round(Math.random() * 240 - 120) + 'deg');
      heart.style.setProperty('--ph-rot-mid', Math.round((Math.random() * 240 - 120) * 0.35) + 'deg');
      layer.appendChild(heart);
    }

    document.body.appendChild(layer);
    setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    }, 4000);
  }

  window.celebrateWholesaleOrder = celebrateWholesaleOrder;
})();
